/**
 * Fog of War configuration. Injected at runtime.
 * RGB colors as normalized [0..1] float triples.
 */
export interface FogOverlayConfig {
  readonly color: readonly [number, number, number];
  readonly alpha: number;
  readonly height: number;
  readonly noiseAmp: number;
  readonly noiseFreq: number;
  readonly layers: number;
  readonly thickness: number;
  readonly layerColors: readonly (readonly [number, number, number])[];
  readonly cloudDensity: number;
  readonly cloudDetail: number;
  readonly cloudContrast: number;
  readonly cloudFlowSpeed: number;
  readonly cloudBaseOpacity: number;
  readonly edgeFadeStrength: number;
  readonly volumetric: {
    readonly enabled: boolean;
    readonly lightDir: readonly [number, number, number];
    readonly highlightStrength: number;
    readonly shadowStrength: number;
    readonly topTint: readonly [number, number, number];
    readonly bottomTint: readonly [number, number, number];
    readonly layerParallax: number;
    readonly normalY: number;
  };
}

export interface FogConfig {
  readonly enabled: boolean;
  readonly overlay: FogOverlayConfig;
}

export function defaultFogConfig(): FogConfig {
  return {
    enabled: true,
    overlay: {
      color: [0.11, 0.12, 0.22],
      alpha: 0.92,
      height: 0.35,
      noiseAmp: 0.22,
      noiseFreq: 1.6,
      layers: 3,
      thickness: 1.1,
      layerColors: [
        [0.12, 0.18, 0.42],
        [0.05, 0.28, 0.22],
        [0.35, 0.02, 0.12],
      ],
      cloudDensity: 0.35,
      cloudDetail: 1.4,
      cloudContrast: 1.3,
      cloudFlowSpeed: 0.05,
      cloudBaseOpacity: 0.65,
      edgeFadeStrength: 0.9,
      volumetric: {
        enabled: true,
        lightDir: [0.35, 0.9, 0.25],
        highlightStrength: 0.45,
        shadowStrength: 0.55,
        topTint: [0.7, 0.8, 1.0],
        bottomTint: [0.04, 0.03, 0.08],
        layerParallax: 0.22,
        normalY: 0.55,
      },
    },
  };
}
